module.exports = __webpack_public_path__ + "static/media/legendary-icon-zoom.6eb96f05.png";